import axios from "axios"
import { TeacherFeedback } from "shared/types/submissionTypes"

export async function feedback({ submissionId }: { submissionId: string }): Promise<TeacherFeedback> {
    const response = await axios.get(`/api/submissions/${submissionId}/feedback`)
    return response.data
}
